import type { Routes } from "@lit-labs/router";

// The single top-level Router/Routes instance (set by the app shell) used for
// programmatic navigation. The Router itself intercepts <a> clicks and popstate;
// this helper covers code-driven navigation (e.g. auth redirects) and keeps the
// URL bar + the router in sync.
let routerRef: Routes | undefined;

export function bindRouter(r: Routes): void {
  routerRef = r;
}

/**
 * navigate performs an in-app navigation to a path (which may include a query
 * string). It updates history and drives the router's goto (which matches on the
 * pathname; pages read location.search themselves).
 */
export function navigate(path: string, opts: { replace?: boolean } = {}): void {
  const url = new URL(path, location.origin);
  const target = url.pathname + url.search;
  if (target === location.pathname + location.search) return;
  if (opts.replace) {
    history.replaceState({}, "", target);
  } else {
    history.pushState({}, "", target);
  }
  void routerRef?.goto(url.pathname);
}
